module.exports = __webpack_public_path__ + "assets/img/bill-over-icon.c122e03c.png";